import React from 'react';
import PropTypes from 'prop-types';
import {
 Card, CardBody, CardImgOverlay, CardSubtitle, CardTitle,
} from 'reactstrap';

const LiveItem = ({
  item,
  type,
  onPlay,
  onDownload,
  onSocialShare,
}) => {
  const getCardItemSubTitle = () => {
    if (type === 'PANORAMIC TOUR') {
      return <CardSubtitle tag="h5">{type}</CardSubtitle>;
    }
    return <CardSubtitle tag="h5">{item.category} | {type}</CardSubtitle>;
  };

  return (
    <div className="review-item">
      <Card>
        {/* <CardImg
        className="image"
        src={`${item.thumb ? item.thumb : item.src}`}
      /> */}
        <div className="container-image">
          <img className="image" src={`${item.thumb ? item.thumb : item.src}`} alt={item.name} />
        </div>
        <CardImgOverlay className="card-overlay">
          <button
            type="button"
            className="play-button"
            aria-label="Open"
            onClick={onPlay}
          >
            <div className={`play-${item.type}-icon`} />
          </button>
        </CardImgOverlay>
        <CardBody>
          <CardTitle tag="h5">{item.name}</CardTitle>
          {getCardItemSubTitle()}

          <div className="card-buttons">
            <button
              type="button"
              className="download-button"
              aria-label="Download"
              onClick={onDownload}
            />
            <button
              disabled
              type="button"
              className="share-button"
              aria-label="Share"
              onClick={onSocialShare}
            />
          </div>

        </CardBody>
      </Card>
    </div>
  );
};

LiveItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    thumb: PropTypes.string,
    type: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
  type: PropTypes.string.isRequired,
  onPlay: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onSocialShare: PropTypes.func.isRequired,
};

export default LiveItem;
